
import { Component, Prop, Mixins} from 'vue-property-decorator'
import Common from '@/mixins/common'
import {DocumentSnapshot, getDoc, getDocs,orderBy,query} from 'firebase/firestore'
import { EventData, EventExtendedProps, MemberMeta, UserPublicProfile } from '@/common-datatypes'
import TemplateMembers from '@/components/TemplateMembers.vue'

//TODO creationTime is undefined


@Component({
  components: {
    TemplateMembers
  }
})

export default class ModalEventHistory extends Mixins(Common) {
  @Prop({type: String, default: ''}) private message?: string
  @Prop({type: String, default: 'message.yes'}) private confirmText?: string
  @Prop({type: String, default: 'message.no'}) private cancelText?: string
  @Prop({type: String, default: ''}) private errorMessage?: string
  @Prop({type: Object, default: {}}) private theEventData?: EventData

  isActive = true
  title = ''
  dateTime = ''
  changelogs = {} 
  exProps = {} as EventExtendedProps
	theEventChangelogs: {[key: string]: EventData} = {}

  selectedHistoryId0 = ''
  selectedHistoryId1 = ''

  fileds = [
    {name: 'title', label: 'formFields.title'},
    {name: 'start', label: 'formFields.startDate'},
    {name: 'end', label: 'formFields.endDate'},
    {name: 'type', label: 'formFields.eventType'},
    {name: 'postStatus', label: 'formFields.postStatus'},
    {name: 'status', label: 'formFields.status'},
    {name: 'className', label: 'formFields.className'},
    {name: 'teacherUserIds', label: 'formFields.teachers'},
    {name: 'studentUserIds', label: 'formFields.students'},
    {name: 'groupName', label: 'formFields.groupName'},
    {name: 'hostUserIds', label: 'formFields.hostMembers'},
    {name: 'guestUserIds', label: 'formFields.guestMembers'},
    {name: 'note', label: 'formFields.note'},
    {name: 'author', label: 'formFields.author'},
  ]

  historyList: Array<{docId: string; creationTime: Date;duration: string}> = []

  getEventLog(field: string){
    const data: {
      0: Date |  string | string[] | {[key: string]: MemberMeta};
      1: Date | string | string[] | {[key: string]: MemberMeta};
      empty: boolean;
      changed: boolean;
    } = {
      0: '',
      1: '',
      empty: false,
      changed: false
    }

    if(this.theEventChangelogs[this.selectedHistoryId0]){
      if(this.theEventChangelogs[this.selectedHistoryId0][field]){
        data[0] = this.theEventChangelogs[this.selectedHistoryId0][field]
      }else if(this.theEventChangelogs[this.selectedHistoryId0].extendedProps[field]){
        data[0] = this.theEventChangelogs[this.selectedHistoryId0].extendedProps[field]
      }
    }

    if(this.$te('event.' + field + '.' + data[0])){
      data[0] = this.$t('event.' + field + '.' + data[0]) as string
    }

    if(this.theEventChangelogs[this.selectedHistoryId1]){
      if(this.theEventChangelogs[this.selectedHistoryId1][field]){
        data[1] = this.theEventChangelogs[this.selectedHistoryId1][field]
      }else if(this.theEventChangelogs[this.selectedHistoryId1].extendedProps[field]){
        data[1] = this.theEventChangelogs[this.selectedHistoryId1].extendedProps[field]
      }
    }

    if(this.$te('event.' + field + '.' + data[1])){
      data[1] = this.$t('event.' + field + '.' + data[1]) as string
    }

    [0,1].forEach(index => {
      const i = index as keyof typeof data
      if(( i === 0 || i === 1)){
        if(this.$te('event.' + field + '.' + data[i])){
          data[i] = this.$t('event.' + field + '.' + data[i]) as string
        }else if(field === 'start' || field === 'end'){
          data[i] = this.$dateTimeFormat(data[i] as Date,'DDDD T (ZZZZ)')
        }else if(field === 'note'){
          data[i] = this.$stripTags(data[i] as string) as string
        }else if(field === 'author'){
          data[i] = this.$t('text.name',{lastName: this.authorMeta[data[i] as string]?.lastName,firstName: this.authorMeta[data[i] as string]?.firstName}) as string
        }
      }
    })

    data.changed = (JSON.stringify(data[0]) !== JSON.stringify(data[1]))

    data.empty = (data[0] === '' && data[1] === '') || (Array.isArray(data[0]) && Array.isArray(data[1]) && data[0].length === 0 && data[1].length === 0)
    
    return data
  }
  
  async created(){
    try{
      if(this.theEventData && this.theEventData.id){
        this.title = this.theEventData.title || ''
        
        const theEventChangelogsRef = query(this.$getEventChangelogsColRef(this.theEventData.extendedProps.docId),orderBy('creationTime','desc'))

        const theEventChangelogsData = await getDocs(theEventChangelogsRef)

        let latestEditBy = ''

        theEventChangelogsData.docs.forEach((doc, index) => {
          //最新のデータは、this.theEventDataに入っているので、ここでは無視する
          const data = doc.data() as EventData
          const author = data.extendedProps.author
          if(index !== 0 ){
            this.theEventChangelogs[doc.id] = data
          }else{
            latestEditBy = author
          }

          if(this.authorMeta[author]){
            //OK
          }else if(data.extendedProps.memberMeta[author]){
          this.authorMeta[author] = data.extendedProps.memberMeta[author]
          }else{
            this.authorMeta[author] = undefined
          }
        })

        const authorPublicProfileDoc = (await Promise.all(Object.keys(this.authorMeta).filter((author) => {
          return this.authorMeta[author] === undefined
        }).map((author) => {
          return getDoc(this.$getUserPublicProfileDocRef(author)) as Promise<DocumentSnapshot<UserPublicProfile>>
        })))

        authorPublicProfileDoc.forEach((doc) => {
          if(doc.exists()){
            const data = doc.data() as UserPublicProfile
            this.authorMeta[doc.id] = {
              ref: doc.ref,
              lastName: data.lastName || '',
              firstName: data.firstName || '',
              lastNameYomigana: data.lastNameYomigana || '',
              firstNameYomigana: data.firstNameYomigana || '',
            }
          }
        })

        this.theEventChangelogs[this.theEventData.id] = {
          ...this.theEventData,
          author: latestEditBy
        }

        this.historyList = Object.keys(this.theEventChangelogs).map((docId) => {
          const creationTime = this.theEventChangelogs[docId].extendedProps.updateTime || new Date()
          return {
            docId: docId,
            creationTime: creationTime,
            duration: this.$duration(creationTime)
          }
        })

        if(this.historyList.length > 1){
          this.historyList.sort((a,b) => {
            return b.creationTime.getTime() - a.creationTime.getTime()
          })
        }

        this.selectedHistoryId0 = this.historyList[0].docId
        this.selectedHistoryId1 = this.historyList[1] ? this.historyList[1].docId : this.historyList[0].docId
      }

      console.log(this.historyList)
    }catch(error){
      console.log(error)
    }
  }

  authorMeta: {[key: string]: MemberMeta | undefined} = {}

  mounted(){    
    //
  }

  onConfirm(yes: boolean) {
    this.$emit("onConfirm", yes);
  }
}
